
















































































import { Component, Vue, Inject } from 'vue-property-decorator';

import AbpBase from '../lib/abpbase';
@Component({
})
export default class Login extends AbpBase {
  lockScreen: boolean = false;
  input: string = '';
  showKeyboard: boolean = false;
  inputs: any = [];
  inputName: string = '';
  loginModel = {
    tenancyName: 'CharterScanners',
    userNameOrEmailAddress: '',
    password: '',
    rememberMe: false,
  };
  showChangeTenant: boolean = false;

  onInputChange(input) {
    this.inputs[input.target.id] = input.target.value;
  }
  onChange(input) {
    this.inputs[this.inputName] = input;
  }
  onKeyPress(button) {}
  onInputFocus(input) {
    this.showKeyboard = true;
    // child will emit an event that we pick up here
    // we change the inputName to the new target
    this.inputName = input.target.id;
  }

  async login() {
    // (this.$refs.loginform as any).validate(async (valid:boolean)=>{
    //    if(valid){
    //       this.$Message.loading({
    //         content:this.L('LoginPrompt'),
    //         duration:0
    //       })
    await this.$store.dispatch({
      type: 'app/login',
      data: this.loginModel,
    });
    sessionStorage.setItem(
      'rememberMe',
      this.loginModel.rememberMe ? '1' : '0'
    );
    location.reload();
    //  }
    // });
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }

  rules = {
    userNameOrEmailAddress: [
      { required: true, message: this.L('UserNameRequired'), trigger: 'blur' },
    ],
    password: [
      { required: true, message: this.L('PasswordRequired'), trigger: 'blur' },
    ],
  };
  created() {
    this.lockScreen = this.$store.state.app.lockScreen;
  }
}
